/** Date-seeded helpers shared by "Country of the day" and the Daily Challenge (same result for everyone, everywhere). */
import { REGION_OF } from "@/lib/introContent";

const DAY_MS = 86400000;
const EPOCH_DAY = 20700; // 2026-09-04 → challenge #1 lands near launch

export const dayNumber = (d = new Date()) => Math.floor((d.getTime() - d.getTimezoneOffset() * 60000) / DAY_MS);
export const challengeNumber = (day = dayNumber()) => day - EPOCH_DAY + 1;

export function mulberry32(seed) {
  let a = seed >>> 0;
  return () => {
    a = (a + 0x6d2b79f5) >>> 0;
    let t = a;
    t = Math.imul(t ^ (t >>> 15), t | 1);
    t ^= t + Math.imul(t ^ (t >>> 7), t | 61);
    return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
  };
}

export function seededShuffle(arr, rnd) {
  const a = [...arr];
  for (let i = a.length - 1; i > 0; i--) {
    const j = Math.floor(rnd() * (i + 1));
    [a[i], a[j]] = [a[j], a[i]];
  }
  return a;
}

const sorted = (countries) => [...countries].filter((c) => !c.disputed).sort((a, b) => a.code.localeCompare(b.code));

export function countryOfDay(countries, day = dayNumber()) {
  const pool = sorted(countries);
  if (!pool.length) return null;
  return seededShuffle(pool, mulberry32(4242))[day % pool.length];
}

const TYPES = ["flag", "capital", "fauna", "currency", "region"];
const regionId = (c) => REGION_OF[c.code]?.id;

/** 5 deterministic questions for `day`: [{type, target, options}] — options are countries, answer = target.code. */
export function dailyQuestions(countries, day = dayNumber()) {
  const pool = sorted(countries);
  if (pool.length < 4) return [];
  const rnd = mulberry32(day * 7919 + 17);
  const targets = seededShuffle(pool, rnd).slice(0, TYPES.length);
  return TYPES.map((type, i) => {
    const target = targets[i];
    const others = pool.filter((c) => c.code !== target.code && (type !== "region" || regionId(c) !== regionId(target)));
    const distractors = seededShuffle(others, rnd).slice(0, 3);
    return { type, target, options: seededShuffle([target, ...distractors], rnd) };
  });
}

export const squares = (picks) => picks.map((ok) => (ok ? "🟩" : "🟥")).join("");
